import {countryByCCA2, zones} from './data';
import template from './timezone-selector.html';

class TimezoneSelector {
  constructor(gettextCatalog) {
    'ngInject';

    this.zones = zones;
    this.translations = {placeholder: gettextCatalog.getString('Select a timezone')};
  }

  getCCA2Label(zone) {
    return countryByCCA2[zone.cca2];
  }
}

export default {
  template,
  bindings: {
    ngModel: '='
  },
  controller: TimezoneSelector,
  controllerAs: 'ctrl'
};
